import { UTSLocale } from "@smile2impress/attraction-constants";

import common from "./common";
import france from "./france";
import germany from "./germany";
import italy from "./italy";
import nl from "./nl";
import portugal from "./portugal";
import spain from "./spain";
import uk from "./uk";
import ukraine from "./ukraine";
import us from "./us";

export default (locale: UTSLocale) => {
    switch (locale) {
        case UTSLocale.SPAIN_ES:
            return spain;
        case UTSLocale.FRANCE_FR:
            return france;
        case UTSLocale.ITALY_IT:
            return italy;
        case UTSLocale.PORTUGAL_PT:
            return portugal;
        case UTSLocale.GB_EN:
            return uk;
        case UTSLocale.UKRAINE_UK:
            return ukraine;
        case UTSLocale.US_EN:
            return us;
        case UTSLocale.GERMANY_DE:
            return germany;
        case UTSLocale.NL_NL:
            return nl;
        default:
            return common;
    }
};
